import { Contact } from 'src/types'

import { InitialValues } from './initial-values'

export default function sanitize(values: InitialValues): InitialValues {
  const sanitized = JSON.parse(JSON.stringify(values))

  if (sanitized.cost_center_id === '') {
    sanitized.cost_center_id = null
    sanitized.cost_center = null
  }

  if (sanitized.reference_id === '') {
    sanitized.reference_id = null
    sanitized.reference = null
  }

  if (sanitized.contract_id === '') {
    sanitized.contract_id = null
    sanitized.contract = null
  }

  return {
    ...sanitized,
    contacts: [
      ...((sanitized.emailContact?.email_contacts?.[0]?.email
        ? [{ ...sanitized.emailContact, contact_type: 'EMAIL' }]
        : []) as Contact[]),
      ...((sanitized.phoneContact?.phone_contacts?.[0]?.phone_number
        ? [{ ...sanitized.phoneContact, contact_type: 'PHONE' }]
        : []) as Contact[])
    ],
    login: `${sanitized.login_splited}${sanitized.login_sufix}`
  }
}
